import vars from '../globals';

let id;
let resizeTimeout = null;

function initSlider(index) {
	const $articles = $(`.article--${index} .related`);
	const $items = $articles.find('.related__slider');

	if ($items.hasClass('slick-initialized')) {
		return;
	}

	$items.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		centerPadding: '10vw',
		centerMode: true,
		infinite: true,
		nextArrow: '<button type="button" class="slick-next related__arrow related__arrow--next"><svg><use xlink:href="/images/sprites.svg#nav-arrow"></use></svg></button>',
		prevArrow: '<button type="button" class="slick-prev related__arrow related__arrow--prev"><svg><use xlink:href="/images/sprites.svg#nav-arrow"></use></svg></button>',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 1,
				},
			}],
	});

	$items.slick('slickRemove', index - 1);

	id = index;
}

function initTestSlider() {
	const $test = $('.test-result .related');
	const $items = $test.find('.related__slider');

	if ($items.hasClass('slick-initialized')) {
		return;
	}

	$items.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		centerPadding: '10vw',
		centerMode: true,
		infinite: true,
		nextArrow: '<button type="button" class="slick-next related__arrow related__arrow--next"><svg><use xlink:href="/images/sprites.svg#nav-arrow-white"></use></svg></button>',
		prevArrow: '<button type="button" class="slick-prev related__arrow related__arrow--prev"><svg><use xlink:href="/images/sprites.svg#nav-arrow-white"></use></svg></button>',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 1,
				},
			}],
	});
}

function destroySlider(index) {
	const $articles = $(`.article--${index} .related`);
	const $items = $articles.find('.related__slider');

	if ($items.hasClass('slick-initialized')) {
		$items.slick('unslick');
	}
}

function destroySliderAll() {
	const $articles = $('.article .related');
	const $items = $articles.find('.related__slider');

	if ($items.hasClass('slick-initialized')) {
		$items.slick('unslick');
	}
}

function destroyTestSlider() {
	const $test = $('.test-result .related');
	const $items = $test.find('.related__slider');

	if ($items.hasClass('slick-initialized')) {
		$items.slick('unslick');
	}
}

function updateSlider(index) {
	const $slider = $(`.article--${index} .related__slider`);

	if ($slider.hasClass('slick-initialized')) {
		$slider.slick('slickGoTo', 0);
	}
}

function updateTestSlider() {
	const $test = $('.test-result .related');
	const $items = $test.find('.related__slider');

	if ($items.hasClass('slick-initialized')) {
		$items.slick('slickGoTo', 0);
	}
}

vars.$window.on('resize', () => {
	if (resizeTimeout) {
		clearTimeout(resizeTimeout);
	}

	resizeTimeout = setTimeout(() => {
		destroySlider(id);
		initSlider(id);
		destroyTestSlider();
		initTestSlider();
	}, 500);
});

export default {
	initSlider,
	initTestSlider,
	destroySlider,
	destroySliderAll,
	destroyTestSlider,
	updateSlider,
	updateTestSlider,
};
